import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  TextField,
  Select,
  FormControl,
  Grid,
  Typography,
  InputLabel,
  MenuItem,
  Button,
  Card,
} from "@material-ui/core";
import { initialValues } from "./values";
import { loginFormValidationSchema } from "./validation";
import Field from "../../../common/components/Field";
import { Formik } from "formik";
import styles from "./styles";

const RegisterDepartment = ({
  classes,
  data,
  isLoading,
  registerDepartment,
}) => {
  const [age, setAge] = React.useState("");
  const [showDepartmentField, setShowDepartmentField] = React.useState(false);

  const handleChange = (event) => {
    setAge(event.target.value);
    if (event.target.value === 1) {
      setShowDepartmentField(true);
    } else {
      setShowDepartmentField(false);
    }
  };
  return (
    <Formik
      initialValues={initialValues()}
      validationSchema={loginFormValidationSchema}
    >
      {(formik) => (
        <div>
          <Card
            style={{
              margin: "auto",
              padding: 10,
              display: "flex",
              maxWidth: 230,
              background: "#fff",
              flexDirection: "column",
            }}
          >
            <Grid container>
              <Grid item>
                <Field
                  formik
                  label="Nome do setor"
                  name="nameDepartment"
                  formik={formik}
                />
                <Field
                  formik
                  label="Descrição"
                  name="description"
                  formik={formik}
                />
                <FormControl className={classes.textField}>
                  <InputLabel id="demo-simple-select-label">
                    É um sub-setor?
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    onChange={handleChange}
                  >
                    <MenuItem value={1}>SIM</MenuItem>
                    <MenuItem value={2}>NÃO</MenuItem>
                  </Select>
                </FormControl>
                {showDepartmentField ? (
                  <div>
                    <Field
                      inputLabel="Setor"
                      options
                      dataOptions={data}
                      name="department"
                      formik={formik}
                    />
                  </div>
                ) : null}
              </Grid>
            </Grid>
            <Button
              onClick={() => registerDepartment(formik.values)}
              className={classes.button}
            >
              CADASTRAR
            </Button>
          </Card>
        </div>
      )}
    </Formik>
  );
};

export default withStyles(styles)(RegisterDepartment);
